import React from 'react';
import ConfirmationButton from '../ConfirmationButton';
import styles from './styles.module.css';

export default function ConfirmModal({
  confirmText,
  rejectText,
  confirmFunction,
  rejectFunction,
  text,
  extraConfirmStyle = '',
  extraRejectStyle = '',
  extraTextStyle = '',
  text2,
}: {
  confirmText: string;
  rejectText: string;
  confirmFunction?: () => void;
  rejectFunction?: () => void;
  text?: string;
  extraConfirmStyle?: string;
  extraRejectStyle?: string;
  extraTextStyle?: string;
  text2?: string;
}) {
  return (
    <>
      <p className={`${styles.text} ${styles.text1} ${extraTextStyle}`}>{text}</p>
      {text2 && <p className={`${styles.text} ${styles.text2} ${extraTextStyle}`}>{text2}</p>}

      <ConfirmationButton
        confirmText={confirmText}
        rejectText={rejectText}
        confirmFunction={() => {
          confirmFunction && confirmFunction();
        }}
        rejectFunction={() => {
          rejectFunction && rejectFunction();
        }}
        extraConfirmStyle={extraConfirmStyle}
        extraRejectStyle={extraRejectStyle}
      />
    </>
  );
}
